var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebIconsQueOfrecemos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b7d87fc7-c6b8-4065-835e-72ee13fa4140,.f365a9cd-9221-495f-b09a-2c5b7bee4b91{fill:none;stroke:#000;stroke-linecap:round;}.b7d87fc7-c6b8-4065-835e-72ee13fa4140{stroke-linejoin:round;stroke-width:19.86px;}.f365a9cd-9221-495f-b09a-2c5b7bee4b91{stroke-miterlimit:10;stroke-width:13.99px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b32dd5e8-1532-4327-a35d-a697159145dd",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b7d87fc7-c6b8-4065-835e-72ee13fa4140",
    d: "M17,291.19H56.66l68.16-42.27H237.41a26.31,26.31,0,0,1,26.32,26.31h0a26.31,26.31,0,0,1-26.32,26.31H169.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b7d87fc7-c6b8-4065-835e-72ee13fa4140",
    d: "M17,366.69H277.09l93.41-58.94A26.75,26.75,0,0,0,378.28,270h0a26.75,26.75,0,0,0-36.18-7.57l-62.84,39.11H200"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f365a9cd-9221-495f-b09a-2c5b7bee4b91",
    d: "M279.83,54.77l-9,21.35v57.73a61.86,61.86,0,0,1-61.87,61.86H181.34l-32.41,23.62H118L93.41,193.7l53.26-25.62S77.83,135.67,116,50c0,0,15.07,59.05,96.48,61.06V77.8a23,23,0,0,1,23-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f365a9cd-9221-495f-b09a-2c5b7bee4b91",
    d: "M151.7,63.81l12.06-24.12a151,151,0,0,0,22.86,45.23"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 86.3,
    r: 9.42
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIconsQueOfrecemos);
export default __webpack_public_path__ + "static/media/web-icons_queOfrecemos.c328a846ce16f83e9c27da70acc0af24.svg";
export { ForwardRef as ReactComponent };